import { baseApi } from '../baseApi';

export const nebulaProfileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfile: builder.query({
      query: () => ({
        url: `/api/personalize/nebula-brain/profiles/current`,
      }),
      transformResponse: (res) => res,
    }),
    createProfile: builder.mutation({
      query: (body) => ({
        url: `/api/personalize/nebula-brain/profiles/create`,
        method: 'POST',
        body,
      }),
      transformResponse: (res) => res,
    }),
    updateProfile: builder.mutation({
      query: (body) => ({
        url: `/api/personalize/nebula-brain/profiles/update`,
        method: 'POST',
        body,
      }),
      transformResponse: (res) => res,
    }),
    rebalanceProfile: builder.mutation({
      query: (body) => ({
        url: `/api/personalize/nebula-brain/profiles/rebalance`,
        method: 'POST',
        body,
      }),
      transformResponse: (res) => res,
    }),
    reinitializeProfile: builder.mutation({
      query: (body) => ({
        url: `/api/personalize/nebula-brain/profiles/reinitialize`,
        method: 'POST',
        body,
      }),
      transformResponse: (res) => res,
    }),
    stopProfile: builder.mutation({
      query: () => ({
        url: `/api/personalize/nebula-brain/profiles/stop`,
        method: 'POST',
      }),
      transformResponse: (res) => res,
    }),
    getJobStatus: builder.query({
      query: (type = 'initialize') => ({
        url: `/api/personalize/nebula-brain/profiles/jobs/${type}`,
      }),
      transformResponse: (res) => res,
    }),
  }),
});

export const {
  useGetProfileQuery,
  useCreateProfileMutation,
  useUpdateProfileMutation,
  useRebalanceProfileMutation,
  useReinitializeProfileMutation,
  useStopProfileMutation,
  useGetJobStatusQuery,
} = nebulaProfileApi;
